import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content" }

import { computed } from "vue";
import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonTitle,
  IonContent,
  IonRow,
  IonCol,
  modalController,
} from "@ionic/vue";
import { closeOutline, star, starOutline } from "ionicons/icons";

export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewDetailModal',
  props: { review: Object },
  setup(__props) {

const props = __props;
const username = computed(
  () => `${props.review?.user?.profile.nickName}`
);
const date = computed(() =>
  new Date(props.review?.updatedAt).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  })
);
const cancel = () => modalController.dismiss(false, "cancel");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonHeader), null, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonButton), {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (cancel()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), { icon: _unref(closeOutline) }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(IonTitle), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.review?.title), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", null, "“" + _toDisplayString(__props.review?.description) + "”", 1),
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), {
                class: "username",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$router.push(`/profile/${__props.review?.user.id}`); cancel()})
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(username.value), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonCol), { class: "ion-text-end rating" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.round(parseFloat(__props.review?.rating)), (n) => {
                    return (_openBlock(), _createBlock(_unref(IonIcon), {
                      icon: _unref(star),
                      class: "yellow-star",
                      key: n
                    }, null, 8, ["icon"]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.round(5 - parseFloat(__props.review?.rating)), (n) => {
                    return (_openBlock(), _createBlock(_unref(IonIcon), {
                      icon: _unref(starOutline),
                      class: "black-star",
                      key: n
                    }, null, 8, ["icon"]))
                  }), 128)),
                  _createTextVNode(" (" + _toDisplayString(__props.review?.rating) + ") ", 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRow), { class: "ion-justify-content-end date" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(date.value), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})